"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M0.822266 1.40625L1.60985 1.66579C2.3035 1.89438 2.83885 2.45176 3.03929 3.15406L5.36227 11.2933C5.81246 12.8706 7.25395 13.9583 8.89428 13.9583H14.0918M10.564 16.7343C10.3176 16.9549 9.99216 17.089 9.63542 17.089C8.86616 17.089 8.24253 16.4654 8.24253 15.6961C8.24253 14.8836 7.69644 13.8705 7 13.4062M3.56614 5L16.7496 3.95968C17.705 3.88128 19.5 4.3125 18.8839 7.1123L18.3283 9.10681C17.9411 10.4967 16.6751 11.4583 15.2323 11.4583H9.11284M13.5022 16.7344C13.7487 16.9549 14.0741 17.089 14.4308 17.089C15.2001 17.089 15.8237 16.4654 15.8237 15.6962C15.8237 14.8837 15.3223 13.9583 14.043 13.9583",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

exports.default = Icon;